<!-- TODO: Make an unit test to this component -->
<script lang="ts">
  import { Button } from '$lib/components/ui/button'
  import { PRICES_API_VEHICLES, SERVICE_TYPES_NAMES } from '$lib/constants'
  import { capitalize, formatCurrency, isAdapted, isLuxury, isDisposal, gtagEvent, getGtagEventData } from '$lib/helpers'
  import { purchaseInfo } from '$lib/stores/booking-info'
  import { locale, localizeUrl, t } from '$lib/translations'
  import type { PlacePosition, BookerPlacesForShuttle } from '$lib/types'
  import { Info, ArrowRight, CheckCircle2, Luggage, Users } from 'lucide-svelte'
  import * as Popover from '$lib/components/ui/popover'
  import { goto } from '$app/navigation'

  export let serviceType: string
  export let vehicleType: string
  export let maxPax: number
  export let luggageQty = 0
  export let price: number
  export let discountType: string | undefined
  export let discountAmount: number | undefined
  export let priceWithFixedRate: number | undefined
  export let startMeetingPoint: PlacePosition | undefined = undefined
  export let endMeetingPoint: PlacePosition | undefined = undefined
  export let bookerPlacesForShuttle: BookerPlacesForShuttle
  export let island: string

  const advantages: string[] = getServiceTypeAdvatages(serviceType, vehicleType)
  let finalPrice = price
  if (discountType && discountAmount && discountAmount > 0) {
    if (discountType === 'percentage') {
      finalPrice = price - (price * discountAmount) / 100
    } else {
      finalPrice = price - discountAmount
    }
  }

  if (!discountAmount && priceWithFixedRate) {
    discountAmount = priceWithFixedRate - price
    discountType = 'amount'
    price = priceWithFixedRate
  }

  const pricePerPerson = formatCurrency(locale.get(), finalPrice / maxPax)

  function getServiceTypeAdvatages(serviceType: string, vehicleType: string): string[] {
    switch (capitalize(serviceType)) {
      case SERVICE_TYPES_NAMES.SHUTTLE:
        return [t.get('common.shutlle_message'), t.get('common.shutlle_message2'), t.get('common.shutlle_message3')]
      case SERVICE_TYPES_NAMES.A_DISPOSICION:
        if (vehicleType == PRICES_API_VEHICLES.WheelChair) {
          return [t.get('services.adapted_description'), t.get('services.adapted_basic_1'), t.get('services.adapted_basic_2')]
        }
        if (vehicleType == PRICES_API_VEHICLES.LuxuryCar || vehicleType == PRICES_API_VEHICLES.LuxuryMinivan) {
          return [t.get('services.premier_basic_1'), t.get('services.premier_basic_2'), t.get('common.private_message3')]
        }
        return [t.get('services.private_basic_1'), t.get('services.private_basic_2')]
      case SERVICE_TYPES_NAMES.PRIVATE:
        if (vehicleType === PRICES_API_VEHICLES.WheelChair) {
          return [t.get('services.adapted_basic_1'), t.get('services.adapted_basic_2')]
        }

        if (vehicleType == PRICES_API_VEHICLES.LuxuryCar || vehicleType == PRICES_API_VEHICLES.LuxuryMinivan) {
          return [t.get('services.premier_basic_1'), t.get('services.premier_basic_2')]
        }

        return [t.get('services.private_basic_1'), t.get('services.private_basic_2')]
      default:
        return ['']
    }
  }
  function getImageByVehicleType(vehicleType: string, island: string) {
    switch (vehicleType) {
      case PRICES_API_VEHICLES.Bus:
        return '/shuttle.png'
      case PRICES_API_VEHICLES.WheelChair:
        return '/adapted.png'
      case PRICES_API_VEHICLES.LuxuryCar:
      case PRICES_API_VEHICLES.LuxuryMinivan:
        if (island == "TNF" || island == "LNZ") {
          return '/minivan.png'
        } else {
          return '/premier.png'
        }
      case PRICES_API_VEHICLES.Car:
      case PRICES_API_VEHICLES.Minivan:
        return '/private.png'
    }
  }

  function updateStoreAndTravel() {
    $purchaseInfo.serviceType = serviceType
    $purchaseInfo.vehicleType = vehicleType

    if (startMeetingPoint) {
      $purchaseInfo.startMeetingPoint = startMeetingPoint
    }
    if (endMeetingPoint) {
      $purchaseInfo.endMeetingPoint = endMeetingPoint
    }
    if (serviceType == SERVICE_TYPES_NAMES.SHUTTLE && bookerPlacesForShuttle) {
      $purchaseInfo.startPlace = bookerPlacesForShuttle.start as PlacePosition
      $purchaseInfo.endPlace = bookerPlacesForShuttle.end as PlacePosition
    }

    goto(localizeUrl('/booking/form', locale.get()))
  }
</script>

<div class="lg:grid lg:grid-cols-4 shadow-lg lg:h-[300px] lg:w-[80%] lg:cursor-auto">
  <div class="hidden lg:col-span-1 lg:flex h-full items-center justify-center p-5">
    <img src={getImageByVehicleType(vehicleType, island)} alt={`Service image: ${serviceType}`} class="object-cover lg:first-letter:h-[150px]" />
  </div>

  <div id="service-details" class="bg-cs-orange lg:bg-white p-5 lg:col-span-2 lg:max-h-[300px]">
    <h1 class="text-white lg:text-cs-orange font-bold lg:text-3xl text-center lg:text-start uppercase flex flex-col lg:flex-row">
      <span>
        {#if isDisposal(serviceType.toLowerCase())}
          {#if isAdapted(vehicleType)}
            {$t('common.atdisposal') + ' ' + $t('common.adapted_service')}
          {:else if isLuxury(vehicleType)}
            {$t('common.atdisposal') + ' ' + $t('common.luxury_service')}
          {:else}
            {$t('common.atdisposal')}
          {/if}
        {:else if isAdapted(vehicleType)}
          {$t('common.adapted_service')}
        {:else if isLuxury(vehicleType)}
          {$t('common.luxury_service')}
        {:else}
          {$t(`common.${serviceType.toLowerCase()}`)}
        {/if}
        {#if startMeetingPoint || endMeetingPoint}
          <Popover.Root>
            <Popover.Trigger class="ml-1 lg:hidden cursor-pointer">
              <Info class="cursor-pointer h-[13.5px] w-[13.5px]" />
            </Popover.Trigger>
            <Popover.Content>
              {$t('common.has_meeting_point_message')}
            </Popover.Content>
          </Popover.Root>
        {/if}
      </span>
    </h1>
    {#if startMeetingPoint || endMeetingPoint}
      <span class="hidden lg:flex text-gray-400 text-sm">* {$t('common.has_meeting_point_message')}</span>
    {/if}

    <div class="hidden lg:flex gap-5 lg:mt-2 w-full">
      <span class="text-base font-semi flex items-center">
        <Users class="h-5 w-5 mr-2 text-cs-light-yellow" />
        {maxPax}
        {$t('common.passengers')}
      </span>
    </div>

    <ul class="mt-4 hidden lg:flex lg:flex-col">
      {#each advantages as advantage}
        <li class="flex flex-row items-center gap-2 text-base">
          <CheckCircle2 class="bg-green-600 rounded-full h-4 w-4 text-white" />
          {advantage}
        </li>
      {/each}
    </ul>
  </div>

  <div id="service-price" class="lg:col-span-1 flex flex-col p-5 font-semibold lg:max-h-[300px] lg:items-end lg:justify-end text-center">
    <p class="hidden lg:flex lg:font-bold text-base">{$t('common.final_price')}</p>
    {#if discountType && discountAmount && discountAmount > 0}
      <div class="flex flex-row justify-center items-center gap-2">
        <span class="hidden lg:flex text-sm bg-cs-orange text-white py-1 px-2 rounded-sm lowercase"
          >{discountType === 'percentage' ? `${discountAmount} %` : formatCurrency(locale.get(), discountAmount)}
          {$t('common.savings')}</span
        >
        <span class="text-xl text-cs-orange lg:text-base text-right">
          {$t('common.before')}: <span class="text-2xl lg:text-xl line-through">{formatCurrency(locale.get(), price)}</span>
        </span>
      </div>
    {/if}

    <span class="text-cs-dark-gray lowercase">{$t('common.from')}</span>

    <h1 class="lg:text-4xl text-3xl text-green-700 lowercase">{formatCurrency(locale.get(), finalPrice)}</h1>

    <p class="text-cs-dark-gray">{$t('common.qty_per_person', { qty: `${pricePerPerson}` })}</p>

    <Button
      on:click={() => updateStoreAndTravel()}
      class="rounded-none transition-all group hover:bg-cs-light-orange  h-12 flex bg-cs-orange uppercase p-0 text-white mt-3"
    >
      <span class="transition-all group-hover:px-6 flex-grow px-8 text-xs lg:text-sm">{$t('common.book_now')}</span>
      <span class="transition-all group-hover:px-6 bg-cs-orange px-4 py-[14px] h-12 text-gray-900 hidden lg:flex">
        <ArrowRight size={18} strokeWidth={2} color={'white'} />
      </span>
    </Button>
    <span class="hidden lg:flex lg:text-sm lg:mt-2">{$t('common.taxes_included')}</span>
  </div>
</div>
